<template>
  <slot></slot>
</template>

<script setup>
import { useEventListener } from "@vueuse/core";
import { useHost } from "vue";

import { useActionForm } from "./composables/useActionForm";
import { props as actionFormProps } from "./props.js";

const props = defineProps(actionFormProps);
const host = useHost();
const { handleClick, handleSubmit } = useActionForm(props);

useEventListener(host, "click", handleClick, { capture: true });
useEventListener(host, "submit", handleSubmit);
</script>

<style>
:host {
  display: contents;
}
</style>
